import React from 'react';
import styled from 'styled-components';
import EventProvider from 'context/events/Event';
import CollapseProvider from 'context/general/Collapse';
import OnSelectMenuProvider from 'context/general/OnSelectMenu';
import DashHeader from 'modules/dashboard/_common/DashHeader';
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions';
import PublicUserPageContent from 'modules/users/public/PublicUserPage';
import breakpoints from 'theme/breakpoints';

// Mesma moldura da página pública de produtor: o cabeçalho do site só no desktop.
export default function PublicUserPage() {
    return (
        <EventProvider>
            <CollapseProvider>
                <OnSelectMenuProvider>
                    <StyledHeader>
                        <DashHeader userView={true} />
                        <DashHeaderActions />
                    </StyledHeader>

                    <PublicUserPageContent />
                </OnSelectMenuProvider>
            </CollapseProvider>
        </EventProvider>
    );
}

const StyledHeader = styled.span`
    display: none;
    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }
`;
